import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Paper, Typography, Button } from "@mui/material";
import { invoiceService } from "../service/InvoiceService";

const InvoiceView = () => {
  const { saleId } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetch = async () => {
      const res = await invoiceService.getInvoice(saleId);
      setData(res);
    };
    fetch();
  }, [saleId]);

  const handlePrint = () => {
    window.print();
  };

  if (!data) return <div>Loading...</div>;

  return (
    <Box sx={{ p: 3, background: "#f5f5f5" }}>
      <Paper id="invoice" sx={{ p: 4, maxWidth: 800, margin: "auto" }}>

        {/* 🔥 HEADER */}
        <Box display="flex" justifyContent="space-between">
          <Box>
            <Typography variant="h5" fontWeight="bold">
              Bankali ENTERPRISE
            </Typography>
            <Typography>Kalna, West Bengal</Typography>
            <Typography>GSTIN: 19ABCDE1234F1Z5</Typography>
          </Box>

          <Box textAlign="right">
            <Typography variant="h6">TAX INVOICE</Typography>
            <Typography>No: {data.invoice.invoiceNo}</Typography>
            <Typography>
              Date: {new Date(data.invoice.date).toLocaleDateString()}
            </Typography>
          </Box>
        </Box>

        <hr />

        {/* 👤 CUSTOMER */}
        <Box mt={2}>
          <Typography fontWeight="bold">Bill To:</Typography>
          <Typography>{data.customer.name}</Typography>
          <Typography>{data.customer.mobile}</Typography>
          <Typography>{data.customer.address}</Typography>
        </Box>

        <hr />

        {/* 🚲 BIKE TABLE */}
        <table width="100%" border="1" cellPadding="8" style={{ marginTop: 10 }}>
          <thead>
            <tr>
              <th>Item</th>
              <th>Engine</th>
              <th>Chasis</th>
              <th>Price</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>Bike</td>
              <td>{data.bike.engine}</td>
              <td>{data.bike.chasis}</td>
              <td>₹ {data.payment.salePrice}</td>
            </tr>
          </tbody>
        </table>

        {/* 💰 GST */}
        <Box mt={2}>
          <Typography>CGST: ₹ {data.payment.cgst.toFixed(2)}</Typography>
          <Typography>SGST: ₹ {data.payment.sgst.toFixed(2)}</Typography>
          {data.payment.igst > 0 && (
            <Typography>IGST: ₹ {data.payment.igst.toFixed(2)}</Typography>
          )}

          <Typography fontWeight="bold" mt={1}>
            Total Amount: ₹ {data.payment.totalAmount.toFixed(2)}
          </Typography>
        </Box>

        <hr />

        {/* 🎁 EXTRAS */}
        <Box mt={2}>
          <Typography fontWeight="bold">Extras:</Typography>
          <Typography>Helmet: {data.extras.helmetQty}</Typography>
          <Typography>Seat Cover: {data.extras.seatCoverQty}</Typography>
 
          {data.extras.gifts?.map((g, i) => (
            <Typography key={i}>
              {g.name} - {g.quantity}
            </Typography>
          ))}
        </Box>

        <hr />

        {/* ✍️ SIGN */}
        <Box display="flex" justifyContent="space-between" mt={4}>
          <Typography>Customer Signature</Typography>
          <Typography>Authorized Signatory</Typography>
        </Box>

      </Paper>

      {/* 🔥 PRINT BUTTON */}
      <Box textAlign="center" mt={3}>
        <Button variant="contained" onClick={handlePrint}>
          Download / Print Invoice
        </Button>
      </Box>
    </Box>
  );
};

export default InvoiceView;